import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface FieldHeaderProps {
  title: string;
  isMandatory: boolean;
}

const FieldHeader = ({ title, isMandatory }: FieldHeaderProps) => (
  <Stack
    direction='row'
    alignItems='center'
    justifyContent='flex-start'
    spacing={1}
    marginBottom='12px'
  >
    <Typography>{title}</Typography>
    {isMandatory && <Typography color='#878787'>(Mandatory)</Typography>}
  </Stack>
);

export default FieldHeader;
